<template>
  <a-drawer
    :destroy-on-close="true"
    :title="isUpdate ? '硬件编辑' : '硬件创建'"
    :visible="visible"
    :width="800"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="位置" prop="location">
        <a-input v-model="form.location" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="设备名称" prop="name">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="品牌" prop="vendor">
        <a-input v-model="form.vendor" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="类型" prop="category">
        <a-input v-model="form.category" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="型号/版本" prop="model">
        <a-input v-model="form.model" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="IP 地址" prop="privateIp">
        <a-input v-model="form.privateIp" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="维保到期时间" prop="expiresAt">
        <a-date-picker v-model="form.expiresAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item
        :wrapper-col="{ span: 20, offset: 4 }"
        style="margin-bottom: 0"
      >
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import {
  getHardwareInventory,
  updateHardwareInventory,
  createHardwareInventory
} from '@/api/inventory.js'

export default {
  name: 'InputDrawer',
  data () {
    return {
      visible: false,
      isUpdate: false,
      form: {
        id: '',
        location: '',
        name: '',
        vendor: '',
        category: '',
        model: '',
        privateIp: '',
        expiresAt: undefined
      },
      rules: {
        name: [
          {
            message: '请输入设备名称',
            required: true,
            trigger: 'blur'
          }
        ],
        vendor: [
          {
            message: '请输入品牌',
            required: true,
            trigger: 'blur'
          }
        ]
      },
      loading: false
    }
  },
  methods: {
    show (id) {
      if (id) {
        this.isUpdate = true
        getHardwareInventory(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              location: data.location,
              name: data.name,
              vendor: data.vendor,
              category: data.category,
              model: data.model,
              privateIp: data.private_ip,
              expiresAt: data.expires_at ? moment(data.expires_at, 'YYYY-MM-DD') : undefined
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer () {
      this.form = {
        id: '',
        location: '',
        name: '',
        vendor: '',
        category: '',
        model: '',
        privateIp: '',
        expiresAt: undefined
      }
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            name: this.form.name,
            vendor: this.form.vendor
          }
          if (this.form.location) params.location = this.form.location
          if (this.form.category) params.category = this.form.category
          if (this.form.model) params.model = this.form.model
          if (this.form.privateIp) params.private_ip = this.form.privateIp
          if (this.form.expiresAt) params.expires_at = this.form.expiresAt.format('YYYY-MM-DD')

          if (this.isUpdate) {
            updateHardwareInventory(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createHardwareInventory(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    }
  }
}
</script>
